import formatIsoDate from '@/services/general/formatIsoDate';
import cloneDeep from 'lodash/cloneDeep';
import * as produitConfig from '@/configuration/catalogue/produitConf';
import prepareSaveReseau from '@/services/catalogue/produitReseau/prepareSaveReseau';
import preparationEnvoiBackReseauTempo from '@/services/bodac/produit/reseauTempo/preparationEnvoiBack/preparationEnvoiBackReseauTempo';

// => Format after get section
// Produit reseau mairie
function formatProduitReseauAfterGet(produit) {
  produit.produitReseau.dateDebut = new Date(produit.produitReseau.dateDebut);
  if (produit.produitReseau.dateFin) {
    produit.produitReseau.dateFin = new Date(produit.produitReseau.dateFin);
  }
}

// Produit reseau mairie
function formatProduitReseauNumeriqueAfterGet(produit) {
  produit.produitReseauNumerique.dateDebut = new Date(produit.produitReseauNumerique.dateDebut);
  if (produit.produitReseauNumerique.dateFin) {
    produit.produitReseauNumerique.dateFin = new Date(produit.produitReseauNumerique.dateFin);
  }
}

// Produit prestation
function formatProduitPrestationAfterGet(produit) {
  produit.dateDebut = new Date(produit.dateDebut);
  if (produit.dateFin) produit.dateFin = new Date(produit.dateFin);
  if (produit.dateSignature) produit.dateSignature = new Date(produit.dateSignature);
  if (produit.dateTarif) produit.dateTarif = new Date(produit.dateTarif);
  produit.selected = false;
}

// Produit salon
function formatProduitSalonAfterGet(produit) {
  produit.produitSalon.dateDebut = new Date(produit.produitSalon.dateDebut);
  if (produit.produitSalon.dateFin) {
    produit.produitSalon.dateFin = new Date(produit.produitSalon.dateFin);
  }
  if (produit.produitSalon.dateSignature) {
    produit.produitSalon.dateSignature = new Date(produit.produitSalon.dateSignature);
  }
  produit.produitSalon.prestations.forEach(formatProduitPrestationAfterGet);
}

// Produit sponsoring
function formatProduitSponsoringAfterGet(produit) {
  produit.produitSponsoring.dateDebut = new Date(produit.produitSponsoring.dateDebut);
  if (produit.produitSponsoring.dateFin) {
    produit.produitSponsoring.dateFin = new Date(produit.produitSponsoring.dateFin);
  }
  if (produit.produitSponsoring.dateSignature) {
    produit.produitSponsoring.dateSignature = new Date(produit.produitSponsoring.dateSignature);
  }
  if (produit.produitSponsoring.prestations) {
    produit.produitSponsoring.prestations.forEach(formatProduitPrestationAfterGet);
  }
}

// Produit Autre
function formatProduitAutreAfterGet(produit) {
  produit.produitAutre.dateDebut = new Date(produit.produitAutre.dateDebut);
  if (produit.produitAutre.dateFin) {
    produit.produitAutre.dateFin = new Date(produit.produitAutre.dateFin);
  }
  if (produit.produitAutre.dateSignature) {
    produit.produitAutre.dateSignature = new Date(produit.produitAutre.dateSignature);
  }
  produit.produitAutre.prestations.forEach(formatProduitPrestationAfterGet);
}

// Produit presse
function formatProduitPresseAfterGet(produit) {
  produit.produitPresse.dateDebut = new Date(produit.produitPresse.dateDebut);
  if (produit.produitPresse.dateFin) {
    produit.produitPresse.dateFin = new Date(produit.produitPresse.dateFin);
  }
  if (produit.produitPresse.dateSignature) {
    produit.produitPresse.dateSignature = new Date(
      produit.produitPresse.dateSignature,
    );
  }
  if (produit.produitPresse.encarts) {
    produit.produitPresse.encarts.forEach((el) => {
      el.dateDebut = new Date(el.dateDebut);
      if (el.dateFin) el.dateFin = new Date(el.dateFin);
      el.selected = false;
    });
  }
  if (!produit.produitPresse.encarts) produit.produitPresse.encarts = [];
}

// Format produit after get
export function formatProduitAfterGet(produitToGet) {
  const produit = cloneDeep(produitToGet);
  produit.commissionsVendeur.forEach((el) => {
    el.dateDebut = new Date(el.dateDebut);
    if (el.dateFin) el.dateFin = new Date(el.dateFin);
    el.selected = false;
  });
  produit.reglesAchat.forEach((el) => {
    el.dateDebut = new Date(el.dateDebut);
    if (el.dateFin) el.dateFin = new Date(el.dateFin);
    el.selected = false;
  });
  produit.objectifsVente.forEach((el) => {
    el.selected = false;
  });
  produit.cgvs.forEach((el) => {
    el.selected = false;
  });
  if (produit.produitFace) {
    produit.produitFace.nomenclature = JSON.parse(produit.produitFace.nomenclature);
  }
  switch (produit.supportCommercial.categorieVente) {
    case produitConfig.CATEGORIE_REGROUPEMENT:
    case produitConfig.CATEGORIE_REGROUPEMENT_LC:
    case produitConfig.CATEGORIE_REGROUPEMENT_MAIRIE:
      formatProduitReseauAfterGet(produit);
      break;
    case produitConfig.CATEGORIE_REGROUPEMENT_NUMERIQUE:
      formatProduitReseauNumeriqueAfterGet(produit);
      break;
    case produitConfig.CATEGORIE_SALON:
      formatProduitSalonAfterGet(produit);
      break;
    case produitConfig.CATEGORIE_SPONSORING:
      formatProduitSponsoringAfterGet(produit);
      break;
    case produitConfig.CATEGORIE_AUTRE:
      formatProduitAutreAfterGet(produit);
      break;
    case produitConfig.CATEGORIE_PRESSE:
      formatProduitPresseAfterGet(produit);
      break;
    default:
      break;
  }
  return produit;
}

// => Format before save section
// Affectations Reseau
function formatAffectationsReseauEcran(produit) {
  const faces = produit.produitReseauNumerique.affectationsReseauEcran;
  const result = [];
  faces.forEach(item => {
    result.push({
      dateDebut: formatIsoDate(item.dateDebut),
      dateFin: formatIsoDate(item.dateFin),
      produitId: item.produit.id,
    });
  });
  return result;
}

// Produit reseau numérique
function formatProduitReseauNumeriqueBeforeSave(produit) {
  produit.produitReseauNumerique.dateDebut = formatIsoDate(
    produit.produitReseauNumerique.dateDebut,
  );
  produit.produitReseauNumerique.dateFin = formatIsoDate(produit.produitReseauNumerique.dateFin);
  produit.produitReseauNumerique.affectationsReseauEcran = formatAffectationsReseauEcran(produit);
}

// Produit numerique
function formatProduitNumeriqueBeforeSave(produit) {
  produit.produitEcranNumerique.codePanneau = produit.reference;
  produit.produitEcranNumerique.codeEcran = produit.reference;
}

// Produit prestation
function formatProduitPrestationBeforeSave(produit) {
  produit.dateDebut = formatIsoDate(produit.dateDebut);
  produit.dateFin = formatIsoDate(produit.dateFin);
  produit.dateSignature = formatIsoDate(produit.dateSignature);
  produit.dateTarif = formatIsoDate(produit.dateTarif);
  if (!produit.isCreate) return;
  delete produit.isCreate;
  delete produit.id;
}

// Produit salon
function formatProduitSalonBeforeSave(produit) {
  produit.produitSalon.dateDebut = formatIsoDate(produit.produitSalon.dateDebut);
  produit.produitSalon.dateFin = formatIsoDate(produit.produitSalon.dateFin);
  produit.produitSalon.dateSignature = formatIsoDate(produit.produitSalon.dateSignature);
  produit.produitSalon.prestations.forEach(formatProduitPrestationBeforeSave);
}

// Produit sponsoring
function formatProduitSponsoringBeforeSave(produit) {
  produit.produitSponsoring.dateDebut = formatIsoDate(produit.produitSponsoring.dateDebut);
  produit.produitSponsoring.dateFin = formatIsoDate(produit.produitSponsoring.dateFin);
  produit.produitSponsoring.dateSignature = formatIsoDate(produit.produitSponsoring.dateSignature);
  produit.produitSponsoring.prestations.forEach(formatProduitPrestationBeforeSave);
}

// Produit Autre
function formatProduitAutreBeforeSave(produit) {
  produit.produitAutre.dateDebut = formatIsoDate(produit.produitAutre.dateDebut);
  produit.produitAutre.dateFin = formatIsoDate(produit.produitAutre.dateFin);
  produit.produitAutre.dateSignature = formatIsoDate(produit.produitAutre.dateSignature);
  produit.produitAutre.prestations.forEach(formatProduitPrestationBeforeSave);
}

// Produit encart
function formatProduitEncartBeforeSave(produit) {
  produit.dateDebut = formatIsoDate(produit.dateDebut);
  produit.dateFin = formatIsoDate(produit.dateFin);
  if (!produit.isCreate) return;
  delete produit.isCreate;
  delete produit.id;
}

// Produit presse
function formatProduitPresseBeforeSave(produit) {
  produit.produitPresse.dateDebut = formatIsoDate(produit.produitPresse.dateDebut);
  produit.produitPresse.dateFin = formatIsoDate(produit.produitPresse.dateFin);
  produit.produitPresse.dateSignature = formatIsoDate(produit.produitPresse.dateSignature);
  produit.produitPresse.encarts.forEach(formatProduitEncartBeforeSave);
}

// Format produit before save
export function formatProduitBeforeSave(produitToSave) {
  let produit = cloneDeep(produitToSave);
  if (produit.liaisonsTarif.length === 1
    && (!produit.liaisonsTarif[0].produitEnfantId)) {
    produit.liaisonsTarif = [];
  }
  produit.liaisonsTarif.forEach(item => {
    item.dateDebut = formatIsoDate(item.dateDebut);
    item.dateFin = formatIsoDate(item.dateFin);
  });
  produit.commissionsVendeur.forEach((el) => {
    el.dateDebut = formatIsoDate(el.dateDebut);
    if (el.dateFin) el.dateFin = formatIsoDate(el.dateFin);
  });
  produit.reglesAchat.forEach(item => {
    item.dateDebut = formatIsoDate(item.dateDebut);
    if (item.dateFin) item.dateFin = formatIsoDate(item.dateFin);
  });
  produit.demandeInterventionTypes.forEach(item => {
    if (!item.isCreate) return;
    delete item.id;
    delete item.isCreate;
  });
  switch (produit.supportCommercial.categorieVente) {
    case produitConfig.CATEGORIE_UNITAIRE:
      produit.produitFace.codeFace = produit.reference;
      break;
    case produitConfig.CATEGORIE_REGROUPEMENT:
      produit = preparationEnvoiBackReseauTempo(produit);
      break;
    case produitConfig.CATEGORIE_REGROUPEMENT_LC:
    case produitConfig.CATEGORIE_REGROUPEMENT_MAIRIE:
      produit = prepareSaveReseau(produit);
      break;
    case produitConfig.CATEGORIE_REGROUPEMENT_NUMERIQUE:
      formatProduitReseauNumeriqueBeforeSave(produit);
      break;
    case produitConfig.CATEGORIE_ECRAN_NUMERIQUE:
      formatProduitNumeriqueBeforeSave(produit);
      break;
    case produitConfig.CATEGORIE_SALON:
      formatProduitSalonBeforeSave(produit);
      break;
    case produitConfig.CATEGORIE_SPONSORING:
      formatProduitSponsoringBeforeSave(produit);
      break;
    case produitConfig.CATEGORIE_AUTRE:
      formatProduitAutreBeforeSave(produit);
      break;
    case produitConfig.CATEGORIE_PRESSE:
      formatProduitPresseBeforeSave(produit);
      break;
    default:
      break;
  }
  return produit;
}
